"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventToMessageType = exports.DefaultDict = void 0;
exports.defaultEventList = defaultEventList;
const event_1 = require("./event");
class DefaultDict {
    constructor(defaultInit) {
        return new Proxy({}, {
            get: (target, name) => name in target ?
                target[name] :
                (target[name] = typeof defaultInit === 'function' ?
                    new defaultInit().valueOf() :
                    defaultInit)
        });
    }
}
exports.DefaultDict = DefaultDict;
function defaultEventList() {
    return (0, event_1.createEvent)("start", { 'nb_rep': 0, 'ref_mesure': 0, 'ref_point': 0 });
}
exports.eventToMessageType = {
    improvement: "improvementMessage",
    improvementInstEvent: "improvementInstMessage",
    regression: "regressionMessage",
    blocked: "blockedMessage",
    stable: "stableMessage",
    objectiveActivation: "objectiveActivationMessage",
    objectiveDeactivation: "objectiveDeactivationMessage",
    activityDeactivation: "activityDeactivationMessage",
    activityActivation: "activityActivationMessage",
};
